import Swal from 'sweetalert2'

const baseConfig = {
  buttonsStyling: false,
  showConfirmButton: false,
  customClass: {
    popup: 'torbit-form-alert',
    title: 'torbit-form-alert__title',
    htmlContainer: 'torbit-form-alert__text',
    icon: 'torbit-form-alert__icon',
  },
  backdrop: 'rgba(17, 17, 17, 0.55)',
  allowOutsideClick: true,
  allowEscapeKey: true,
  showClass: {
    popup: 'torbit-form-alert-show',
  },
  hideClass: {
    popup: 'torbit-form-alert-hide',
  },
}

export function showFormLoading() {
  return Swal.fire({
    ...baseConfig,
    title: 'Sending Enquiry',
    html: 'Please wait while we send your message...',
    allowOutsideClick: false,
    allowEscapeKey: false,
    showConfirmButton: false,
    didOpen: () => {
      Swal.showLoading()
    },
  })
}

export function closeFormAlert() {
  Swal.close()
}

export function showFormSuccess(message) {
  return Swal.fire({
    ...baseConfig,
    icon: 'success',
    title: 'Enquiry Sent Successfully',
    text: message,
    timer: 5000,
    timerProgressBar: true,
  })
}

export function showFormError(message) {
  return Swal.fire({
    ...baseConfig,
    icon: 'error',
    title: 'Unable to Send Enquiry',
    text: message,
    timer: 5000,
    timerProgressBar: true,
  })
}

export function showFormValidationError(message) {
  return Swal.fire({
    ...baseConfig,
    icon: 'warning',
    title: 'Please Check Your Details',
    text: message,
    timer: 4500,
    timerProgressBar: true,
  })
}
